<template>
  <v-bottom-navigation
    v-model="active"
    background-color="transparent"
    color="#FFD700"
    grow
    height="64"
    class="mobile-nav"
    active-class="active-nav-btn"
  >
    <v-btn
      text
      to="/"
      exact
      aria-label="Início"
    >
      <span>
        <img src="@/assets/images/home.png" alt="Home" class="mobile-icon-img" />
      </span>
    </v-btn>

    <v-btn
      text
      to="/comunidade"
      aria-label="Comunidade"
    >
      <span>
        <img src="@/assets/images/comunidade.png" alt="Comunidade" class="mobile-icon-img" />
      </span>
    </v-btn>

    <v-btn
      text
      to="/marketplace"
      class="marketplace-btn"
      aria-label="Marketplace"
    >
      <span>
        <img src="@/assets/images/carrinho.png" alt="Marketplace" class="mobile-icon-img" />
      </span>
    </v-btn>

    <v-btn
      text
      to="/zinnes"
      class="zinnes-btn"
      aria-label="Originais Zinnes"
    >
      <span>
        <img src="@/assets/images/zinnes.png" alt="Originais Zinnes" class="zinnes-icon" />
      </span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
    };
  }
};
</script>


<style scoped>
.mobile-nav {
  position: fixed;
  right: max(12px, calc(50% - 260px));
  bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  left: max(12px, calc(50% - 260px));
  width: auto !important;
  max-width: 520px;
  overflow: hidden;
  border-radius: 22px;
  background: rgba(16, 12, 20, 0.82) !important;
  box-shadow:
    0 18px 42px rgba(0, 0, 0, 0.38),
    0 5px 14px rgba(0, 0, 0, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    inset 0 0 0 1px rgba(255, 255, 255, 0.06);
  -webkit-backdrop-filter: blur(18px) saturate(145%);
  backdrop-filter: blur(18px) saturate(145%);
  z-index: 999;
}

.mobile-nav .v-btn {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  height: 56px !important;
  margin: 4px;
  min-width: 60px !important;
  border-radius: 18px;
  transition-property: background-color, box-shadow, transform;
  transition-duration: 180ms;
  transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
}

.mobile-nav .v-btn:active {
  transform: scale(0.96);
}

.mobile-nav .v-btn:focus-visible {
  outline: 2px solid rgba(255, 215, 0, 0.9);
  outline-offset: -4px;
}

.mobile-nav .v-btn .v-icon {
  color: white !important;
  font-size: 28px;
  transition: color 180ms cubic-bezier(0.2, 0, 0, 1);
}

.mobile-icon-img {
  width: 35.28px;
  height: 35.28px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: 0.82;
  transition-property: filter, opacity, transform;
  transition-duration: 180ms;
  transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
}

.zinnes-icon {
  width: 42.8px;
  height: 42.8px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: 0.82;
  transition-property: filter, opacity, transform;
  transition-duration: 180ms;
  transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
}

/* Estado ativo via v-bottom-navigation */

.mobile-nav .v-btn--active .v-icon {
  color: #FFD700 !important;
}

.mobile-nav .v-btn--active .mobile-icon-img,
.v-btn.v-btn--active .mobile-icon-img,
.v-btn.router-link-active .mobile-icon-img {
  filter: brightness(0) saturate(100%) invert(66%) sepia(99%) saturate(1500%) hue-rotate(0deg) brightness(104%) contrast(101%);
  opacity: 1;
  transform: translateY(-1px);
}

.mobile-nav .v-btn--active .zinnes-icon {
  filter: brightness(0) saturate(100%) invert(66%) sepia(99%) saturate(1500%) hue-rotate(0deg) brightness(104%) contrast(101%);
  opacity: 1;
  transform: translateY(-1px);
}

/* Estado ativo via router-link */
.v-btn.v-btn--active .v-icon,
.v-btn.router-link-active .v-icon {
  color: #FFD700 !important;
}

.v-btn.v-btn--active .zinnes-icon,
.v-btn.router-link-active .zinnes-icon {
  filter: brightness(0) saturate(100%) invert(66%) sepia(99%) saturate(1500%) hue-rotate(0deg) brightness(104%) contrast(101%);
  opacity: 1;
  transform: translateY(-1px);
}

.mobile-nav .v-btn--active,
.mobile-nav .v-btn.router-link-active {
  background: rgba(255, 215, 0, 0.13);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 4px 14px rgba(255, 215, 0, 0.08);
}

@media (min-width: 320px) and (max-width: 650px) {
  .mobile-nav {
    display: flex;
  }
}

@media (min-width: 651px) {
  .mobile-nav {
    display: none;
  }
}

@media (max-width: 359px) {
  .mobile-nav {
    right: 8px;
    bottom: calc(8px + env(safe-area-inset-bottom, 0px));
    left: 8px;
    width: auto !important;
    border-radius: 20px;
  }

  .mobile-nav .v-btn {
    margin-right: 2px;
    margin-left: 2px;
    min-width: 52px !important;
    border-radius: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-nav .v-btn,
  .mobile-nav .v-icon,
  .mobile-icon-img,
  .zinnes-icon {
    transition-duration: 0.01ms !important;
  }
}
</style>
